import { createChart } from "bi-sdk";
export const setGaugeRadius = function (chartId, count) {
  let itemColor = ["#FF6E66", "#FDBE71", "#6AD6C7", "#5BEE9D"],
    centerWidth = 64,
    pointerWidth = 8;
  let chart = createChart(
    {
      title: {
        text: "舒适度指标",
        bottom: 10,
        left: "center",
        textStyle: {
          fontSize: 12,
          color: "#4E5969"
        }
      },
      grid: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        containLabel: true
      },
      series: [
        {
          type: "gauge",
          startAngle: 220,
          endAngle: -40,
          splitNumber: 20,
          center: ["50%", "50%"],
          radius: "100%",
          pointer: {
            show: true,
            icon: "triangle",
            length: pointerWidth,
            width: pointerWidth - 1,
            offsetCenter: [0, -centerWidth / 2],
            itemStyle: {
              color: "#4E5969"
            }
          },
          anchor: {
            show: false
          },
          detail: {
            color: "#1D2129",
            fontWeight: "bold",
            offsetCenter: [0, 5],
            fontSize: 24
          },
          splitLine: {
            show: false,
            distance: -10,
            lineStyle: {
              color: "#fff"
            }
          },
          axisLabel: {
            show: true,
            distance: 18,
            color: "#86909C",
            padding: [0, 0, 0, 0],
            fontSize: 12,
            formatter: function (value) {
              if (value === 90) {
                return "优";
              } else if (value === 70) {
                return "良";
              } else if (value === 35) {
                return "中";
              } else if (value === 10) {
                return "差";
              }
              return "";
            }
          },
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 10,
              color: [
                [0, itemColor[0]],
                [0.2, itemColor[0]],
                [0.205, "#fff"],
                [0.5, itemColor[1]],
                [0.505, "#fff"],
                [0.8, itemColor[2]],
                [0.805, "#fff"],

                [1, itemColor[3]]
              ]
            }
          },
          progress: {
            show: false
          }
        },
        {
          silent: true,
          name: "白色底盘",
          type: "pie",
          radius: [0, 32],
          label: {
            show: false
          },
          zlevel: -1,
          center: ["50%", "50%"],
          roseType: "radius",
          itemStyle: {
            normal: {
              color: "#fff",
              shadowBlur: 6,
              shadowOffsetX: 0,
              shadowOffsetY: 4,
              shadowColor: "rgba(134, 144, 156, 0.2)"
            }
          },
          tooltip: {
            show: false
          }
        },
        {
          name: "边框",
          silent: true,
          type: "pie",
          radius: ["27", "28"],
          label: {
            show: false
          },
          zlevel: 4,
          center: ["50%", "50%"],
          roseType: "radius",
          itemStyle: {
            normal: {
              color: "#F2F3F5"
            }
          },
          tooltip: {
            show: false
          }
        }
      ]
    },
    { extend: [""] }
  );
  chart.dataSet({
    source: [["name"], [count]]
  });
  chart.amount(chartId);
  return chart;
};
export const setGaugePowerRate = function (chartId) {
  let chart = createChart(
    {
      series: {
        type: "gauge",
        radius: "97",
        splitNumber: 10,
        axisLine: {
          roundCap: false,
          lineStyle: {
            width: 12,
            color: [
              [
                1,
                {
                  // type: "linear",
                  // x: 0,
                  // y: 0,
                  // x2: 1,
                  // y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#FFA4B2"
                    },
                    {
                      offset: 0.5,
                      color: "#81ADF9"
                    },
                    {
                      offset: 0.75,
                      color: "#69EEBE"
                    },
                    {
                      offset: 1,
                      color: "#91E9C7"
                    }
                  ],
                  global: false
                }
              ]
            ]
          }
        },
        itemStyle: {
          color: "#7983F5"
        },
        progress: {
          roundCap: false,
          show: false,
          width: 8,
          itemStyle: {
            color: "#7983F5"
          }
        },
        pointer: {
          length: 45,
          width: 5,
          itemStyle: {
            color: "#4E5969"
          }
        },
        splitLine: {
          length: 6,
          distance: 8,
          lineStyle: {
            width: 1,
            color: "#C9CDD4"
          }
        },
        anchor: {
          show: true,
          showAbove: true,
          size: 14,
          itemStyle: {
            borderWidth: 5,
            borderColor: "#4E5969"
          }
        },
        detail: {
          valueAnimation: true,
          fontSize: 36,
          offsetCenter: [0, "80%"],
          formatter: function (value) {
            return "{value|" + value.toFixed(0) + "}{unit|%}";
          },
          rich: {
            value: {
              fontSize: 36,
              color: "#1D2129",
              fontWeight: "bolder"
            },
            unit: {
              fontSize: 16,
              color: "#1D2129",
              fontWeight: "bolder"
            }
          }
        },
        axisLabel: {
          distance: 12,
          color: "#C9CDD4",
          fontSize: 12
        }
      }
    },
    {
      extend: [],
      theme: {}
    } // extend内容会使用默认配置
  );
  chart.dataSet({
    source: [["name"], [30]]
  });
  chart.amount(chartId);
  return chart;
};
export const setGaugeWarning = function (chartId, count) {
  let chart = createChart(
    {
      title: {
        text: "系统评分",
        bottom: 0,
        left: "center",
        textStyle: {
          fontSize: 12,
          color: "#4E5969"
        }
      },
      series: {
        type: "gauge",
        radius: "80",
        splitNumber: 10,
        axisLine: {
          roundCap: false,
          lineStyle: {
            width: 8
          }
        },
        itemStyle: {
          color: "#7983F5"
        },
        progress: {
          roundCap: false,
          show: true,
          width: 8,
          itemStyle: {
            color: "#7983F5"
          }
        },
        pointer: {
          length: 45,
          width: 5,
          itemStyle: {
            color: "#7983F5"
          }
        },
        splitLine: {
          length: 6,
          distance: 8,
          lineStyle: {
            width: 1,
            color: "#C9CDD4"
          }
        },
        anchor: {
          show: true,
          showAbove: true,
          size: 14,
          itemStyle: {
            borderWidth: 5,
            borderColor: "#7983F5"
          }
        },
        detail: {
          valueAnimation: true,
          offsetCenter: [0, "60%"],
          fontSize: 24,
          color: "#1D2129",
          fontWeight: "bolder"
        },
        axisLabel: {
          distance: 12,
          color: "#C9CDD4",
          fontSize: 12
        }
      }
    },
    {
      extend: [],
      theme: {}
    } // extend内容会使用默认配置
  );
  chart.dataSet({
    source: [["name"], [count]]
  });
  chart.amount(chartId);
  return chart;
};
